<template>
  <div>
    <nav class="breadcrumb_box" aria-label="breadcrumb" v-if="SearchData">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
          <li class="breadcrumb-item active" aria-current="page">{{ SearchData.Keyword }} {{ $t('搜尋結果') }}</li>
        </ol>
      </div>
    </nav>
    <template v-if="SearchData">
      <!-- 文章列表 -->
      <div class="wrapper list">
        <section class="list_news">
          <div class="container">
            <div class="title_box">
              <h2>{{ SearchData.Keyword }} {{ $t('搜尋結果') }}</h2>
            </div>
            <ul class="list_main" v-if="total > 0">
              <li v-for="Post in Posts" :key="Post.PId">
                <a href="javascript:void(0)" @click="gotoPost(Post)">
                  <div class="time">
                    <div class="rectangle_bg">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                    <p>{{ Post.PublicStartTime | timeString("YYYY/MM/DD") }}</p>
                  </div>
                  <p>{{ Post.Title }}</p>
                </a>
              </li>
            </ul>
            <div style="min-height: 200px;" v-else>
              {{ $t('查無相關文章') }}
            </div>
          </div>
          <nav class="page_box" aria-label="Page navigation example" v-if="total > 0">
            <div class="container">
              <ul class="pagination">
                <li class="page-item">
                  <a class="page-link" href="javascript:void(0)" aria-label="Previous"
                    @click="pageNow - 1 >= 1 ? loadList(pageNow - 1) : loadList(pageNow)">
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
                <!-- 第一頁 -->
                <li class="page-item" :class="{ disabled: pageNow === 1 }">
                  <a :class="pageNow == 1 ? 'page-link-active' : ''" class="page-link" href="javascript:void(0)"
                    @click="loadList(1)">1</a>
                </li>
                <!-- 左側省略號 -->
                <li v-if="startPage > 2" class="page-item disabled">
                  <a class="page-link">...</a>
                </li>
                <!-- 中間頁面 -->
                <li v-for="index in visiblePages" :key="index" class="page-item">
                  <a :class="pageNow == index ? 'page-link-active' : ''" class="page-link" href="javascript:void(0)"
                    @click="loadList(index)">
                    {{ index }}
                  </a>
                </li>
                <!-- 右側省略號 -->
                <li v-if="endPage < pageAll - 1" class="page-item disabled">
                  <a class="page-link">...</a>
                </li>
                <!-- 最後一頁 -->
                <li class="page-item" :class="{ disabled: pageNow === pageAll }" v-if="pageAll > 1">
                  <a :class="pageNow == pageAll ? 'page-link-active' : ''" class="page-link" href="javascript:void(0)"
                    @click="loadList(pageAll)">{{ pageAll }}</a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="javascript:void(0)" aria-label="Next"
                    @click="pageNow + 1 <= pageAll ? loadList(pageNow + 1) : loadList(pageNow)">
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </section>
      </div><!-- wrapper -->
    </template>
  </div>
</template>

<script>
import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  zh_tw: {
    "首頁": "首頁",
    "搜尋結果": "搜尋結果",
    "查無相關文章": "查無相關文章",
  },
  en: {
    "首頁": "Home",
    "搜尋結果": "Search results",
    "查無相關文章": "No related articles found",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "Search",
  i18n,
  components: {
    Slick,
  },
  data() {
    return {
      SearchData: null,
      local: "zh_tw",
      PostTabIndex: -1,
      Keyword: "",
      Posts: null,
      pageAll: 0,
      perPage: 10,
      pageNow: 1,
      total: 0,
      maxVisiblePages: 5,
    };
  },
  computed: {
    // 計算顯示範圍的起始頁
    startPage() {
      const half = Math.floor(this.maxVisiblePages / 2);
      return Math.max(2, this.pageNow - half); // 從第2頁開始
    },
    // 計算顯示範圍的結束頁
    endPage() {
      const half = Math.floor(this.maxVisiblePages / 2);
      return Math.min(this.pageAll - 1, this.pageNow + half); // 到倒數第2頁為止
    },
    // 中間可見頁面
    visiblePages() {
      const pages = [];
      for (let i = this.startPage; i <= this.endPage; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
  beforeRouteUpdate(to, from, next) {
    Vue.axios
      .get(
        this.$store.state.src +
        this.$store.state.subDirectory +
        "/GCIT/Search",
        {
          params: { Keyword: to.params.Keyword, lang: $cookies.get("gcit_the_site_lang") },
        }
      )
      .then((response) => {
        this.SearchData = response.data;
        this.pageNow = 1;
        this.loadList(this.pageNow);
      })
      .catch((error) => {
        console.log(error);
      });
    next();
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src +
        this.$store.state.subDirectory +
        "/GCIT/Search",
        {
          params: { Keyword: this.$route.params.Keyword, lang: $cookies.get("gcit_the_site_lang") },
        }
      )
      .then((response) => {
        this.SearchData = response.data;
        this.pageNow = 1;
        this.loadList(this.pageNow);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("gcit_the_site_lang")) {
      i18n.locale = $cookies.get("gcit_the_site_lang");
      this.local = $cookies.get("gcit_the_site_lang");
    } else {
      i18n.locale = $cookies.get("gcit_the_site_lang");
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
    loadList: function (page) {
      var that = this;
      $.ajax({
        url:
          this.$store.state.src +
          this.$store.state.subDirectory +
          "/GCIT/SearchList",
        type: "post",
        data: {
          Keyword: that.SearchData.Keyword,
          page: page,
          perPage: that.perPage,
          lang: $cookies.get("gcit_the_site_lang"),
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.status == 1) {
            that.total = res.total;
            that.pageNow = page;
            that.Posts = res.Posts;
            that.perPage = res.perPage;
            that.pageAll = Math.max(Math.ceil(res.total / that.perPage), 1);
            // $('html, body').animate({
            //   scrollTop: $('#list_posts').offset().top
            // }, 0);
          }
        },
      });
    },
    gotoPost(Post) {
      if (Post.Type == 1) {
        if (Post.Blank) {
          window.open(Post.Url, "_blank");
        } else {
          location.href = Post.Url;
        }
      } else {
        this.$router.push({
          name: "Post",
          params: { PId: Post.PId },
        });
      }
    },
    gotoUrl: function (Url, Blank) {
      if (Blank) {
        window.open(Url, "_blank");
      } else {
        location.href = Url;
      }
    },
  },
};
</script>
